import {
  Box,
  Typography,
} from '@mui/material';
import { WhiteBgCard } from 'components';
import React from 'react';
import { Bar } from 'react-chartjs-2';
import './index.scss';

export default function EarningsBreakDown() {
  const data = {
    labels: ['DIGITAL SESSION', 'LIVE SESSION', 'LIVE CLASS', 'CONTENT ONLY', 'COURSE'],
    datasets: [{
      label: 'Earnings',
      backgroundColor: '#9092BE',
      data: [5, 6, 7, 8, 4],
    }],
  };

  const subscriptionData = {
    labels: ['PROFILE', 'GROUPS'],
    datasets: [{
      categoryPercentage: 0.3,
      barPercentage: 1,
      label: 'Earnings',
      backgroundColor: '#9092BE',
      data: [5, 2],
    }],
  };

  const options = {
    barValueSpacing: 1,
    barDatasetSpacing: 1,
    scales: {
      x: {
        ticks: {
          display: false,
          beginAtZero: true,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
      y: {
        ticks: {
          padding: 1,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
    indexAxis: 'y' as const,
    plugins: {
      datalabels: {
        display: true,
        color: 'text.primary',
      },
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="col-12 col-lg-5 mb-4">
      <WhiteBgCard>
        <div className="row mb-2 align-items-start">
          <div className="col-12 col-md-auto">
            <div className="d-flex flex-column">
              <Typography variant="body1" sx={{ color: 'text.primary' }}>
                Earnings breakdown
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.primary', mt: 1 }}>
                from sessions
              </Typography>
            </div>

          </div>
        </div>
        <Bar data={data} options={options} />
        <Box sx={{ height: 125, position: 'relative' }}>
          <div className="row align-items-start">
            <div className="col-12 col-md-auto">
              <div className="d-flex flex-column">
                <Typography variant="body2" sx={{ color: 'text.primary' }}>
                  from subscriptions
                </Typography>
              </div>
            </div>
          </div>
          <Bar data={subscriptionData} options={options} className="subscriptionBar" />
        </Box>
      </WhiteBgCard>
    </div>
  );
}
